// Whether the app is being loaded from the LMS subdomain (learn.
// austrianprocess.com) rather than the main site. App.js renders an
// entirely different route tree and nav depending on this.
//
// The REACT_APP_FORCE_LEARN_SUBDOMAIN override exists only for local dev
// testing (`REACT_APP_FORCE_LEARN_SUBDOMAIN=true npm start`), since there's
// no real subdomain to load from on localhost. Gated behind
// NODE_ENV !== 'production' so it's structurally impossible for it to do
// anything in a real production build, regardless of what env vars happen
// to be set.
export function isLearnSubdomain() {
  if (typeof window === 'undefined') return false;
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_FORCE_LEARN_SUBDOMAIN === 'true') {
    return true;
  }
  return window.location.hostname.split('.')[0] === 'learn';
}

export const LEARN_SUBDOMAIN_URL = 'https://learn.austrianprocess.com';
export const MAIN_SITE_URL = 'https://www.austrianprocess.com';
